import Immutable from 'immutable';
import * as types from './AdminHelpDesk.types';

const initialState = {
    type: null,
    requests: [],
    fetching: false,
    sending: false,
    idModal: null,
    pagination: {
        totalElements: 0,
        activePage: 1,
        totalPages: 0,
        elementsPerPage: 15,
    },
    request: null,
    sort: {
        column: 'id',
        type: 'desc',
    },
    search: '',
    searchType: 'name',
    responseMessage: '',
    closingTicket: false,
}

export default function (state = initialState, action) {
    state = Immutable.fromJS(state);
    switch (action.type) {
        case types.FETCH_REQUESTS:
            return state.setIn(['fetching'], true).toJS();

        case types.FETCH_REQUESTS_SUCCESS:
            return state.setIn(['fetching'], false)
                .setIn(['requests'], action.payload.elements)
                .setIn(['pagination', 'totalElements'], action.payload.totalElements)
                .setIn(['pagination', 'activePage'], action.payload.activePage)
                .setIn(['pagination', 'totalPages'], action.payload.totalPages)
                .setIn(['pagination', 'elementsPerPage'], action.payload.elementsPerPage)
                .toJS();

        case types.FETCH_REQUESTS_ERROR:
            return state.setIn(['fetching'], false).toJS();

        case types.SEND_RESPONSE:
            return state.setIn(['sending'], true).toJS();

        case types.SEND_RESPONSE_SUCCESS:
            return state.setIn(['sending'], false)
                .setIn(['idModal'], null)
                .toJS();

        case types.SEND_RESPONSE_ERROR:
            return state.setIn(['sending'], false).toJS();

        case types.CLOSE_TICKET:
            return state.setIn(['closingTicket'], true).toJS();

        case types.CLOSE_TICKET_SUCCESS:
            return state.setIn(['closingTicket'], false)
                .setIn(['idModal'], null)
                .toJS();

        case types.CLOSE_TICKET_ERROR:
            return state.setIn(['closingTicket'], false).toJS();

        case types.SET_ID_MODAL:
            return state.setIn(['idModal'], action.payload).toJS();

        case types.SET_ACTIVE_PAGE:
            return state.setIn(['pagination', 'activePage'], action.payload).toJS();

        case types.SET_REQUEST_FIELD:
            return state.setIn(['request', action.payload.field], action.payload.value).toJS();

        case types.SET_REQUEST:
            return state.setIn(['request'], action.payload).toJS();

        case types.RESET_REQUEST:
            return state.setIn(['request'], null).toJS();

        case types.SET_SORT:
            return state.setIn(['sort', 'type'], action.payload.type)
                .setIn(['sort', 'column'], action.payload.column)
                .toJS();

        case types.SET_SEARCH:
            return state.setIn(['search'], action.payload).toJS();

        case types.SET_SEARCH_TYPE:
            return state.setIn(['searchType'], action.payload).toJS();

        case types.SET_RESPONSE_MESSAGE:
            return state.setIn(['responseMessage'], action.payload).toJS();

        case types.RESET_STATE:
            return initialState;

        default:
            return state.toJS();
    }
}